import React from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { SelectRadioButton } from '../../ui';
import { PaperStatus, PaperStatusName } from '../../../store/paper-status/types';
import { AppState } from '../../../store/state';
import { selectPaperStatusState } from '../../../store/selectors';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { updatePaperStatusBulkDTO } from '../../../store/info/types';
import submissionSlice from '../../../store/submission/slice';
import { useTranslation } from 'react-i18next';
import { Role } from '../../../store/conference/types';

interface Props extends SimpleDialogProps {
  initialOption?: string;
  submissionIds: number[];
  paperStatusById: { [key: number]: PaperStatus };
  updatePaperStatusBulkAction: (data: updatePaperStatusBulkDTO) => void;
  role: Role;
}

const PaperStatusChangeDialog: React.FC<Props> = ({
  initialOption,
  submissionIds,
  paperStatusById,
  updatePaperStatusBulkAction,
  role,
  ...rest
}) => {
  const { t, i18n } = useTranslation();
  const [selectedOption, setSelectedOption] = React.useState<string | undefined>(initialOption);

  const getOptions = (role: Role) => {
    let options: { id: string; label: string }[];
    switch (role.type) {
      case 'reviewer':
      case 'chair':
        options = Object.values(paperStatusById)
          .filter((paperStatus) => !(['Deleted'] as PaperStatusName[]).includes(paperStatus.name))
          .map((value) => ({ id: value.id.toString(), label: value.name }));
        break;
      default:
        options = [];
    }
    return options;
  };

  return (
    <SimpleDialog
      {...rest}
      title={t('Edit paper status')}
      handleOk={
        selectedOption
          ? () => updatePaperStatusBulkAction({ submissionIds, paper_status_id: parseInt(selectedOption) })
          : undefined
      }
    >
      <SelectRadioButton
        className="flex flex-col space-y-3"
        value={selectedOption}
        options={getOptions(role)}
        onChange={(value) => setSelectedOption(value)}
      />
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({
  paperStatusById: selectPaperStatusState(state).paperStatusById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  updatePaperStatusBulkAction: (data: updatePaperStatusBulkDTO) =>
    dispatch(submissionSlice.actions['UPDATE:PAPER-STATUS:BULK'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaperStatusChangeDialog);
